import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@projectobelisk/uikit/components/feedback/empty";
import { createFileRoute } from "@tanstack/react-router";
import { PhoneCall } from "lucide-react";

export const Route = createFileRoute("/_app/call-center/call-list")({
  staticData: { title: "Call List", breadcrumb: "Call List" },
  component: CallList,
});

function CallList() {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <PhoneCall />
        </EmptyMedia>
        <EmptyTitle>No calls yet</EmptyTitle>
        <EmptyDescription>
          Completed calls will be listed here once your team starts dialing.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
